import React, {useEffect, useState} from "react";
import {View, StyleSheet, TouchableOpacity} from "react-native";
import PtText from "../pt-text/pt-text";
import {styleVars} from "../../../app-style-vars";
import PtTab from "./pt-tab";

export default function PtTabsContainer(props:any) {
  console.log('props children = ', props.children);
  const childrenArray = props.children ?
    Array.isArray(props.children) ?
      props.children
      : [props.children]
    : [];
  console.log('children array = ', childrenArray);
  const tabs = childrenArray.filter((child:any) => (child.type == PtTab));
  const initialActiveTab = tabs.indexOf(tabs.find((tab:any) => (tab.props.active))) < 0 ?
    0 : tabs.indexOf(tabs.find((tab:any) => (tab.props.active)));

  const [activeTabIndex, setActiveTabIndex] = useState(initialActiveTab);

  const activateTab = (tabIndex: number) => {
    setActiveTabIndex(tabIndex);
  }

  useEffect(() => {
    setActiveTabIndex(initialActiveTab)
  },[initialActiveTab]);

  return (
    <View>
      <View style={[styles.tabHeadersContainer]}>
        <View style={[styles.tabHeadersScrollContainer]}>
          {tabs.map((tab:any, idx:number) => (
              <View style={[styles.tab ]} key={idx}>
                <TouchableOpacity onPress={() => activateTab(idx)}>
                  {idx === activeTabIndex ?
                    <View style={[styles.tabTitleContent ]}>
                      <PtText style={[styles.tabTitleText, styles.tabTitleTextActive]}>
                        {tab.props.title}
                      </PtText>
                      <View style={[styles.activeTabIndicator]}/>
                    </View>
                    :
                    <View style={[styles.tabTitleContent ]}>
                      <PtText style={[styles.tabTitleText]}>
                        {tab.props.title}
                      </PtText>
                    </View>
                  }
                </TouchableOpacity>
              </View>
          ))}
        </View>
      </View>
      <View style={[styles.tabsContentContainer]}>
        {tabs.map((child:any, idx:number) => (
          child.type == PtTab ?
            idx == activeTabIndex ?
              <View style={[styles.tabContentContainer, styles.activeTabContentContainer]} key={idx}>
                {child}
              </View>
              :
              <View style={[styles.tabContentContainer]} key={idx}>
                {child}
              </View>
            : null
        ))}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  tabHeadersContainer: {
    flex: 1,
    flexWrap: 'nowrap',
    overflow: 'hidden',
    borderColor: '#000'
  },
  tabHeadersScrollContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    alignContent: 'flex-start',
    flexWrap: 'nowrap',
    overflow: 'visible',
  },
  tab: {
    flex: 1,
    flexBasis: .25,
    flexShrink: 1,
    flexGrow: 1,
    paddingHorizontal: styleVars.rem(1),
    justifyContent: 'center',
    alignItems: 'stretch',
    /*minWidth: '25%',*/
    overflow: 'hidden'
  },
  tabTitleContent: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    flexShrink: 1,
    flexGrow: 1,
    minHeight: styleVars.rem(3),
    maxHeight: styleVars.rem(3),
    overflow: 'hidden',
    paddingBottom: styleVars.rem(.25),
  },
  tabTitleText: {
    fontSize: styleVars.rem(1),
    fontWeight: 'normal',
    color: '#000',
    textAlign: 'center'
  },
  tabTitleTextActive: {
    fontWeight: 'bold',
    color: styleVars.boschDarkBlue,
  },
  activeTabIndicator: {
    position: 'absolute',
    bottom: 0,
    borderBottomWidth: 2,
    borderBottomColor: styleVars.boschDarkBlue,
    zIndex: 2,
    width: '100%'
  },
  tabsContentContainer: {
    borderTopWidth: 1,
    borderTopColor: styleVars.boschLightGray
  },
  tabContentContainer: {
    display: 'none',
    flex: 0,
    justifyContent: 'flex-start',
    marginHorizontal: 0,
    marginVertical: 8,
  },
  activeTabContentContainer : {
    display: 'flex'
  }
});